
/*
Copyright 2023 Breautek

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { FuseContext } from "../FuseContext";
import { FuseContextBuilder } from "../FuseContextBuilder";
import { FuseTestAPIFactory } from "./FuseTestAPIFactory";
import { FuseTestContextFactory } from './FuseTestContextFactory';
import { FuseTestPlataformResolver } from "./FuseTestPlatformResolver";

export class FuseTestContextBuilder extends FuseContextBuilder {
    public constructor() {
        super();
        this.setPlatformResolver(new FuseTestPlataformResolver())
            .setAPIFactory(new FuseTestAPIFactory())
            .setContextFactory(new FuseTestContextFactory());
    }
    
    protected override async _isDebugMode(context: FuseContext): Promise<boolean> {
        return true;
    }
}
